import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { HumanGate } from "../../../shared/types";

export function useGate(gateId: string | undefined) {
  return useQuery({
    queryKey: ["human-gate", gateId],
    queryFn: () => api.get<{ data: HumanGate }>(`/api/human-gates/${gateId!}`),
    enabled: !!gateId,
  });
}

export function useGateAction(gateId: string | undefined) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { action: string; comment?: string }) =>
      api.post(`/api/human-gates/${gateId!}/action`, payload),
    onSuccess: () => {
      // Invalidate both the single gate and the pending list
      void queryClient.invalidateQueries({ queryKey: ["human-gate", gateId] });
      void queryClient.invalidateQueries({ queryKey: ["human-gates-pending"] });
    },
  });
}
